var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-xxs uppercase tracking-wide text-grey-dark font-semibold h-8 mb-1 flex items-center justify-center"},[(_vm.category.name == '')?_c('span',[_vm._v("\n             \n        ")]):_c('span',[_vm._v("\n            "+_vm._s(_vm.category.name)+"\n        ")])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }